import { Image } from "@/ui";
import classes from "../styles.module.scss";

/**
 * Image side of the highlight card. The image is cropped to fill the column at any text length.
 *
 * @param {Object} [image] - CMS image.
 * @param {string} [imageAlt] - Alt text; falls back to the CMS alt.
 * @param {string} [imagePosition] - Focal point passed to object-position, e.g. "center center".
 * @returns {JSX.Element|null}
 */
export default function HighlightMedia({ image, imageAlt, imagePosition }) {
  if (!image?.url) return null;

  return (
    <div
      className={classes.highlightBox__media}
      style={{ "--hb-img-pos": imagePosition }}
      data-sourceflow-prop="image"
    >
      <Image img={image.url} size="1200x" alt={imageAlt || image.alt || ""} />
    </div>
  );
}
